export const SET_IS_MOBILE = "SET_IS_MOBILE";
export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
